import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTable from 'components/organisms/data-table'
import tableColumns from '../../molecules/table-column/customer-checkout-table-columns'

const propTypes = {
  cart              : PropTypes.object,
  onFetchData       : PropTypes.func,
  isLoading         : PropTypes.bool,
  hiddenColumns     : PropTypes.arrayOf(PropTypes.string),
  selectedCartItems : PropTypes.array,
  toggleAllCheckbox : PropTypes.func,
  toggleCheckbox    : PropTypes.func,
  rowButtonProps    : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    onButtonClick    : PropTypes.func,
    isButtonDisabled : PropTypes.bool
  })
}

const defaultProps = {
  cart              : {},
  hiddenColumns     : [],
  isLoading         : false,
  selectedCartItems : [],
  toggleAllCheckbox : () => {},
  toggleCheckbox    : () => {},
  rowButtonProps    : {
    buttonText       : 'Process',
    buttonColour     : 'default',
    onButtonClick    : () => {},
    isButtonDisabled : false
  }
}

/**
 * Table to display Customer Cart Items columns for specific customer
 * @param {Object} cart - object of cart
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 */
const CustomerCheckoutTable = ({
  cart,
  hiddenColumns,
  onFetchData,
  isLoading,
  rowButtonProps,
  selectedCartItems,
  toggleAllCheckbox,
  toggleCheckbox
}) => {

  const { buttonText, buttonColour, onButtonClick, isButtonDisabled } = rowButtonProps
  const cartItems                                                     = cart.items

  const columns = useMemo(
    () => tableColumns({
      buttonText,
      buttonColour,
      onButtonClick,
      isButtonDisabled,
      cartItems,
      selectedCartItems,
      toggleAllCheckbox,
      toggleCheckbox
    }),
    [
      buttonColour,
      buttonText,
      onButtonClick,
      isButtonDisabled,
      cartItems,
      selectedCartItems,
      toggleAllCheckbox,
      toggleCheckbox
    ]
  )

  return (
    <DataTable
      data={ cartItems }
      columns={ columns }
      onFetchData={ onFetchData }
      isLoading={ isLoading }
      hiddenColumns={ hiddenColumns }
    />
  )
}

CustomerCheckoutTable.propTypes    = propTypes
CustomerCheckoutTable.defaultProps = defaultProps

export default CustomerCheckoutTable
